module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lgMTT"))).then(() => module.bundle.root('hEqeo'));